import { Assert } from '@team/assert';

export function valueOrFallback<T>(value: Maybe<T>, fallback: T): T {
  if (Assert.isUndefined(value)) {
    return fallback;
  }

  return value;
}
